$(function () {
    // Benefits Slider (mobile)
    $(window).on('load resize orientationchange', function () {
        var slider = $('.flex-split--dc-benefits');
        if (window.matchMedia("(min-width: 768px)").matches) {
            if (slider.hasClass('slick-initialized')) {
                slider.slick('unslick');
            }
        }
        else {
            if (!slider.hasClass('slick-initialized')) {
                slider.slick({
                    infinite: true,
                    prevArrow: '.dc-benefits__slide-prev',
                    nextArrow: '.dc-benefits__slide-next',
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    mobileFirst: true
                });
            }
        }
    });
});
